import CampaignConversionStatsApi from '@/services/api/campaignConversionStatsApi'

const CampaignConversionStatsStore = {
  namespaced: true,
  state: {
    stats: []
  },
  mutations: {
    saveStats: (state, payload) => {
      state.stats = payload.data
    },
    resetStats: state => {
      state.stats = []
    }
  },
  actions: {
    fetchCampaignConversionStats ({ state, commit }, payload) {
      return CampaignConversionStatsApi.getConversionStats(payload.campaignConversionStatsId)
        .then(response => {
          commit('saveCampaignConversionStats', response.data)
          Promise.resolve(state.campaignConversionStats)
        })
    }
  },
  getters: {
  }

}

export default CampaignConversionStatsStore
